<template>
  <div class="hidden sm:block w-2/12">
    <!-- Card Moderno -->
    <div class="bg-white rounded-xl shadow-lg overflow-hidden sticky top-24">
      <!-- Links do menu -->
      <nav class="py-2">
        <router-link 
          to="/users" 
          class="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150 border-l-4 border-transparent hover:border-gray-500"
          active-class="bg-gray-50 text-gray-900 border-gray-500">
          <i class="fas fa-users w-5 text-gray-600"></i>
          <span class="font-medium">Usuários</span>
        </router-link>

        <router-link 
          to="/approval"
          class="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150 border-l-4 border-transparent hover:border-gray-500"
          active-class="bg-gray-50 text-gray-900 border-gray-500">
          <i class="fas fa-user-check w-5 text-gray-600"></i>
          <span class="font-medium">Lista de Aprovação</span>
        </router-link>

        <router-link 
          to="/user-form"
          class="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150 border-l-4 border-transparent hover:border-gray-500"
          active-class="bg-gray-50 text-gray-900 border-gray-500">
          <i class="fas fa-user-plus w-5 text-gray-600"></i>
          <span class="font-medium">Cadastrar Usuário</span>
        </router-link>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationUsers'
}
</script>
